function getOnlyNumbers(value: unknown): string | undefined {
  if (typeof value !== 'string') {
    return
  }

  return String(value.replace(/[^0-9]/g, ''))
}

export default getOnlyNumbers
